import React from "react";
import CheckIcon from "../../../assets/svg/check-icon";
import { OptionItemProps } from "../types";

const OptionItem: React.FC<OptionItemProps> = ({
  option,
  index,
  dropdownId,
  isSelected,
  isFocused,
  isDisabled,
  optionClassName,
  onOptionToggle,
  onFocusedIndexChange,
  selectedOptionClassName,
}) => {
  return (
    <div
      key={option.value || `${dropdownId}-option-${index}`}
      id={`${dropdownId}-option-${index}`}
      role="option"
      aria-selected={isSelected}
      aria-disabled={isDisabled}
      tabIndex={-1}
      className={`
        flex items-center gap-[10px] cursor-pointer border-b border-border-gray dark:border-border-gray-dk 
        last:border-b-0 transition-colors px-[14px] py-[10px] min-w-0
        ${
          isDisabled
            ? "opacity-50 "
            : isFocused
              ? "bg-hover-effect dark:bg-hover-effect-dk"
              : "hover:bg-hover-effect dark:hover:bg-hover-effect-dk"
        }
        ${isSelected && `${selectedOptionClassName}`}
        ${optionClassName}
      `}
      onClick={() => onOptionToggle(option)}
      onMouseEnter={() => !isDisabled && onFocusedIndexChange(index)}
    >
      <div
        className={`shrink-0 w-[14px] h-[14px] border border-gray-100 dark:border-gray-100-dk rounded-[3px] flex items-center justify-center ${
          isSelected
            ? "bg-verba-blue text-pure-white dark:bg-verba-blue-dk dark:text-pure-white-dk border-verba-blue dark:border-verba-blue-dk"
            : ""
        }`}
      >
        {isSelected && (
          <CheckIcon className="w-3 h-3 text-pure-white dark:text-pure-white-dk" />
        )}
      </div>

      <div className="flex-1 min-w-0 select-none">{option.content}</div>
    </div>
  );
};

export default OptionItem;
